module.exports = __webpack_public_path__ + "static/media/accountsettings.9d7b6dda.svg";